{
  "feedback-internal-success-page": {
    "buttons": {
      "to-salon": "AU SALON"
    },
    "text": {
      "thanks": "Merci pour vos commentaires",
      "thanks-again": "Vos commentaires sont très précieux pour nous aider à améliorer notre service"
    }
  }
}
